<template>
  <b-col cols="12">
    <b-table
      class="table-bordered border"
      :fields="fields"
      :items="movement.objects"
      show-empty
      hover
      responsive
      :empty-text="$t('empty_text')"
    >
      <template #head()="props">
        <span>{{ $t(props.label) }}</span>
      </template>

      <template #cell(index)="{ index }">
        <span>{{ index + 1 }}</span>
      </template>


      <template #cell(count)="{ value }">
        {{ $_formatPriceMixin(value) }}
      </template>

      <template #cell(remainder)="{ value }">
        {{ $_formatPriceMixin(value) }}
      </template>

      <template #cell(notEnough)="data">
        {{
          data.item.other_count > data.item.remainder
            ? data.item.other_count - data.item.remainder
            : 0
        }}
      </template>

      <template #cell(actions)="data">
        <span class="d-flex">
          <b-button
            :disabled="data.item.isSaved"
            size="sm"
            class="mt-50 mb-50"
            variant="danger"
            @click="$emit('deleleRequest', data.index)"
          >
            <feather-icon icon="Trash2Icon" />
          </b-button>
        </span>
      </template>
    </b-table>
  </b-col>
</template>

<script>
import {
  BButton,
  BCol,
  BTable,
} from "bootstrap-vue";
import priceFormatMixin from "@/mixins/priceFormatMixin";
import loader from "@/mixins/loader";

export default {
  components: {
    // BRow,
    BCol,
    BTable,
    BButton,
  },
  mixins: [priceFormatMixin, loader],
  props: {
    movement: {
      type: Object,
      default: () => ({}),
    },
    checkIsSaved: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    // ===============  PRIMARY_DATA_SECTION START ===============
    fields: [
      {
        label: "№",
        key: "index",
        thClass: "text-center",
        tdClass: "text-center",
        thStyle: { width: "5%" },
      },
      {
        label: "reference.categoriya",
        key: "instrument.type.category.title",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "Model",
        key: "instrument.title",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "reference.name",
        key: "instrument.type.title",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "amount",
        key: "count",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "remaining_stock",
        key: "remainder",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "lacks",
        key: "notEnough",
        thClass: "text-center",
        tdClass: "text-center",
        thStyle: { width: "20%" },
      },
    ],
    // ===============  PRIMARY_DATA_SECTION END ===============
  }),
  async mounted() {
    await this.$_loaderStart();
  },
  async beforeRouteLeave(to, from, next) {
    await this.$_loaderStop();
    next();
  },
};
</script>

<style>
</style>
